module.exports = __webpack_public_path__ + "static/media/CT_2019_30448_8721_pdf.9429b395.pdf";